import { useContext, useState, useEffect, useCallback, useMemo } from 'react';
import { referenceDataSlice } from 'redux/reducers';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';
import { ButtonRow, ContentWrapper, Popup, Button } from 'components/generic';
import { OnboardingContext } from 'providers/onboarding-provider';
import { useFetch } from 'hooks';
import { ContactUs, SubDetails } from './components';
import Images from 'assets/Images';
import { helpList } from 'config';
import { cloneDeep } from 'lodash';

import './style.scss';

const Onboarding = () => {
	const context = useContext(OnboardingContext);
	const { createObj, setCreateObj } = context;
	const [validation, setValidation] = useState(false);
	const [successPopup, setSuccessPopup] = useState(false);
	const [contactToggler, setContactToggler] = useState(false);
	const [helpListToggler, setHelpListToggler] = useState(false);

	const navigate = useNavigate();
	const api = useFetch();
	const dispatch = useDispatch();

	const currentSection = useMemo(() => createObj?.op_formContent?.op_sectionList?.find(el => el?.op_sectionKey === createObj?.op_currentSection), [createObj]);

	// handle on click of save button
	const handleSave = e => {
		window.scrollTo(0, 0);
		if (e === 'Save & Next' || e === 'Submit') {
			setCreateObj(prevState => {
				const data = cloneDeep(prevState);
				data.op_formContent.op_sectionList.find(el => el.op_sectionKey === data.op_currentSection).op_status = 'COM';
				data.op_status = e === 'Submit' ? 'COM' : 'PEN';
				handleclientData(data);
				return data;
			});
		}

		if (e === 'Back') {
			const currentIndex = createObj?.op_formContent?.op_sectionList?.findIndex(el => el?.op_sectionKey === createObj?.op_currentSection);
			setCreateObj(prevState => {
				const data = cloneDeep(prevState);
				data.op_currentSection = createObj?.op_formContent?.op_sectionList[currentIndex - 1]?.op_sectionKey;
				return data;
			});
		}
	};

	// Onboarding api call
	const getClientAPI = async () => {
		const c_id = localStorage.getItem('c_id');
		const { data } = await api({ url: `client/v1/?c_id=${c_id}`, method: 'get' });
		const el = data?.data?.c_formData;
		el.op_formContent = JSON.parse(el?.op_formContent);
		el?.op_status === 'COM' && setSuccessPopup(true);
		el.country = data?.data?.c_country;
		context?.setCreateObj(el);
	};

	useEffect(() => {
		createObj && setValidation(validate());
	}, [createObj]);

	// Onboarding validation
	const validate = useCallback(() => {
		let valid = true;
		currentSection?.op_subsections?.map((headers, i) => {
			headers?.ss_form.map((el, j) => {
				!currentSection.op_subsections[i].ss_form[j].f_value && el?.f_isMandatory === 'Y' && headers?.ss_display && (valid = false);
			});
		});
		return valid;
	}, [createObj]);

	// handleclientData and updateClientAPI
	const handleclientData = obj => {
		const data = { c_id: localStorage.getItem('c_id'), op_status: obj?.op_status };
		obj?.op_formContent?.op_sectionList?.map(section => {
			section?.op_subsections?.map(subSection => {
				subSection?.ss_key === 'c_inviteMembers' && (data[section?.op_sectionKey][subSection?.ss_key] = []);
				subSection?.ss_form?.map(el => {
					!data[section?.op_sectionKey] && (data[section?.op_sectionKey] = {});
					subSection?.ss_key === 'c_inviteMembers' || (!data[section?.op_sectionKey][subSection?.ss_key] && subSection?.ss_key !== '' && (data[section?.op_sectionKey][subSection?.ss_key] = {}));

					subSection?.ss_key === ''
						? (data[section.op_sectionKey][el?.f_key] = el?.f_value)
						: subSection?.ss_key === 'c_inviteMembers'
						? data[section?.op_sectionKey][subSection?.ss_key].push({ emailId: el?.f_value, role: '' })
						: (data[section?.op_sectionKey][subSection?.ss_key][el?.f_key] = el?.f_value);
				});
			});
		});
		updateClientAPI({ data, createObj: obj });
	};

	// referenceData  api
	const setBaseData = async () => {
		const refData = await api({ url: 'referenceData/v1', method: 'get' });
		dispatch(referenceDataSlice?.actions?.referenceDataReducer(refData?.data?.data));
	};

	useEffect(() => {
		setBaseData();
		getClientAPI();
	}, []);

	// updateClient api call
	const updateClientAPI = async ({ data, createObj }) => {
		const form = new FormData();
		form.append('op_formContent', JSON.stringify(createObj?.op_formContent));
		form.append('op_currentSection', createObj?.op_currentSection);
		form.append('op_clientConfig', JSON.stringify(data));
		form.append('op_status', data?.op_status);
		form.append('op_medium', 'SIGNUP');
		createObj?.op_formContent?.op_sectionList?.map(sectionList => sectionList?.op_subsections?.map(headers => headers?.ss_display && headers?.ss_form.map(el => el?.f_type === 'upload' && form.append(el?.f_key, el?.f_value))));
		await api({ url: 'client/v1/updateClient', method: 'patch', data: form });
		await getClientAPI();
	};

	const successHandler = () => {
		setSuccessPopup(false);
		navigate('/');
	};

	const onboardingFlows = (
		<ul className='onboarding-flow__progress'>
			{createObj?.op_formContent?.op_sectionList?.map((el, i) => (
				<li key={i} className='onboarding-flow__progress__item' style={{ flex: `0 0 ${100 / createObj?.op_formContent?.op_sectionList?.length}%` }}>
					<span
						className={classNames({
							'onboarding-flow__progress__count': true,
							'onboarding-flow__progress__count--success': el?.op_status === 'COM',
							'onboarding-flow__progress__count--default': el?.op_status === 'PEN',
							'onboarding-flow__progress__count--current': el?.op_sectionKey === createObj?.op_currentSection
						})}
					></span>
					<span>{el?.op_sectionValue}</span>
				</li>
			))}
		</ul>
	);

	// handle help list click
	const helpClickHandler = key => {
		key === 'faq' && navigate('/faq');
		key === 'tutorial' && navigate('/tutorial');
		key === 'contactus' && setContactToggler(true);
	};

	// popup content
	const createPopupContent = useMemo(() => {
		return (
			<Popup onClose={() => setSuccessPopup(false)} popupState={successPopup}>
				<div className='onboarding-flow__completed'>
					<img src={Images?.congratulations} />
					<h1>Congratulations!</h1>
					<h3>You have successfully completed your onboarding-flow process</h3>
					<Button compact primary label='OK' handleOnSubmit={successHandler} />
				</div>
			</Popup>
		);
	}, [successPopup]);

	// helplist items
	const helpListItems = useMemo(
		() =>
			helpListToggler && (
				<ul className='onboarding-flow__helpList'>
					{helpList?.map((el, i) => (
						<li key={i} onClick={() => helpClickHandler(el?.key)}>
							<img src={Images[el?.key]} alt={el?.name} />
							{el?.name}
						</li>
					))}
				</ul>
			),
		[helpListToggler]
	);

	const saveContactUsAPI = async e => {
		await api({ url: 'client/v1/contactUs', method: 'post', data: e, successToaster: true });
		setHelpListToggler(false);
		setContactToggler(false);
	};

	return (
		<div className='layout-wrap'>
			<div className='onboarding-flow__header'>
				<img src={Images?.loginLogo} alt='App logo' width='30px' height='30px' />
				<h4>{process.env.REACT_APP_NAME}</h4>
			</div>

			<div className='onboarding-flow'>
				<div className='onboarding-flow__container'>
					{onboardingFlows}
					<div className='onboarding-flow__details'>
						<ContentWrapper shadow fullHeight>
							<SubDetails />
							<ButtonRow
								label={createObj?.op_formContent?.op_sectionList?.findIndex(el => el?.op_sectionKey === currentSection?.op_sectionKey) > 0 ? 'Back' : 'None'}
								label1={currentSection?.op_sectionKey === 'c_declaration' ? 'Submit' : 'Save & Next'}
								right
								handleButtonClick={handleSave}
								disableSave={!validation}
							/>
						</ContentWrapper>

						<img src={Images?.help} className='onboarding-flow__help' alt='upload' onClick={() => setHelpListToggler(prevState => !prevState)} />

						{helpListItems}

						{createPopupContent}

						<Popup onClose={() => setContactToggler(false)} popupState={contactToggler}>
							<ContactUs onSave={saveContactUsAPI} />
						</Popup>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Onboarding;
